<template>
  <div>
    <CRow>
      <CCol>
        <div class="mb-1">
          <label :for="fileFor">{{ name }}</label>
          <input type="file" :name="fileFor" :id="fileFor" class="upload-photo" @change="onFileChange" accept="image/png, image/jpg, image/jpeg, image/webp" />
        </div>
        <div class="mb-2" style="color: #A7A8AA;">{{ guideline() }}</div>
        <div v-if="sourceImageRendered !== ''" class="mb-2">
          <CImg :src="sourceImageRendered" alt="illustration-image.png" :fluid="true" :style="styleImage" />
        </div>
        <div class="text-danger" v-if="errData && errData !== ''">{{ errData }}</div>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import BannerListUseCase from "./../app/usecase/index.js"

export default {
  name: "ChooseFile",
  props: {
    fileFor: {
      required: true,
      type: String,
    },
    name: {
      type: String,
      default: "Choose File",
    },
    imageSize: {
      default: 2, // 2 MB
      type: Number,
    },
    expectedImageHeightWidth: {
      required: true,
      type: Object,
    },
    previousImage: {
      required: true,
      type: String,
    }
  },
  data() {
    return {
      // guideline: "Recommended size 1152 x 300 px, max 2MB. JPG/JPEG/PNG",
      urlLocal: "",
      errData: null,
      styleImage: {}
    }
  },
  computed: {
    sourceImageRendered() {
      return this.urlLocal !== '' ? this.urlLocal : this.previousImage
    }
  },
  methods: {
    guideline() {
      // const giveNameBanner = this.fileFor.split("-")
      // return giveNameBanner.includes("mobile") ? "Recommended size 480 x 272 px, max 2MB. JPG/JPEG/PNG/WebP" : "Recommended size 2304 x 600 px, max 2MB. JPG/JPEG/PNG/WebP"
      return `Recommended size ${this.expectedImageHeightWidth.max.width} x ${this.expectedImageHeightWidth.max.height} px, max 2MB. JPG/JPEG/PNG/WebP`
    },
    async onFileChange(e) {
      e.preventDefault();
      const files = e.target.files || e.dataTransfer.files;
      if (files.length > 0) {
        const resultValidate = BannerListUseCase.validateFileData(files[0], this.imageSize)
        const {
          dataUrl,
          err: errNotFollowGuideline
        } = await BannerListUseCase.validateImageHeightAndWidth(files[0], this.expectedImageHeightWidth)
        this.urlLocal = dataUrl
        if ((resultValidate && resultValidate !== '') || errNotFollowGuideline) {
          this.errData =  resultValidate || errNotFollowGuideline
          this.styleImage.opacity = "0.5"
          this.$emit("retrieve-file", null)
        } else {
          this.errData = null
          this.styleImage.opacity = "1"
          this.$emit("retrieve-file", files)
        }
      }
    },
  }
}
</script>

<style scoped>
.upload-photo {
  opacity: 0;
  position: absolute;
  z-index: -1;
}

label {
  cursor: pointer;
  border: 1px solid;
  padding: .85rem 3rem;
  border-radius: 5px;
  font-weight: 600;
}
</style>
